import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Spanje",
  "description": "",
  "published": "2006-07-12T00:00:00.000Z",
  "redirect_from": ["/blog/spanje/swizec/397"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Spanje... je bedno. Res je, da ga telo potrebuje in oÄitno tudi mentalna vsebina moÅ¾gan, vsaj glede na znanost, ki naj bi v tem Äasu bila tista ta-pametna.`}</p>
    <p>{`Ampak lahko ste gotovi, da takoj, ko doÅ¾ivite veÄ spanca kot kolikor ste navajeni pride do marsikaterega problema. Tako na primer je dan kar naenkrat Äarobno krajši in ne morete opraviti vsega, kar je potrebno, tak spanec vas tudi pusti povsem zaspane, zmatrane in drugaÄe narobe.`}</p>
    <p>{`Vse to dobi piko na i, ko v trenutku usedanja na kolo za odhod v sluÅ¾bo priÄne deÅ¾evati potem pa morate neznansko dolgo Äakati na avtobus, vse skupaj zaÄinjeno z vrnitvijo do kolesa, ki je bilo oÄitno ukradeno... jupi.`}</p>
    <p>{`V glavnem... spanje je bedno.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      